import {
  PriceBox,
  PriceBoxBottomLabel,
  PriceBoxTopLabel,
  PriceItemProps
} from "@silversea-ssc/ui-components-react";
import {
  fromPiceLabel,
  transformPriceFrom,
  withLowestFareAvailableLabel
} from "components/Prices/utils";
import React from "react";
import { EnhancedAvailablePriceWithFareCode } from "src/ssc-api/prices/types";
import { Currency } from "src/utils/localization/currency";
import { useLingui } from "@lingui/react/macro";
import { useStaticFareLabels } from "features/fare/use-static-fare-labels";

type Props = {
  price: EnhancedAvailablePriceWithFareCode | undefined;
  currency: Currency;
  variant?: PriceItemProps["variant"];
};

const LowestPrice: React.FC<Props> = ({ price, currency }) => {
  const { fareCodeLabel } = useStaticFareLabels();
  const { t } = useLingui();
  const firstPrice = price
    ? transformPriceFrom(
        t,
        price,
        currency,
        true,
        "without-from",
        fareCodeLabel
      )
    : undefined;

  const isWaitlist = firstPrice?.type == "waitlist";
  const bottomLabel = isWaitlist
    ? undefined
    : t(withLowestFareAvailableLabel());

  return (
    <>
      {firstPrice ? (
        <PriceBox
          price={firstPrice}
          chipBackgroundColor="neutral05"
          topLabel={
            <PriceBoxTopLabel uppercase>{t(fromPiceLabel())}</PriceBoxTopLabel>
          }
          bottomLabel={
            bottomLabel ? (
              <PriceBoxBottomLabel uppercase>{bottomLabel}</PriceBoxBottomLabel>
            ) : undefined
          }
        />
      ) : (
        <React.Fragment>&nbsp;</React.Fragment>
      )}
    </>
  );
};

export default LowestPrice;
